var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.article && _vm.userCanEdit)?_c('div',{staticClass:"wiki-admin"},[_c('mcr-button',{attrs:{"href":_vm.adminEditLink,"target":"_blank"}},[_vm._v("Edit")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }